var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "expand" } }, [
    _c(
      "div",
      {
        staticClass: "form",
        attrs: { id: "flow", "data-aos": "fade-up", "data-aos-duration": "400" }
      },
      [
        _c(
          _vm.type,
          _vm._b(
            { tag: "component" },
            "component",
            {
              steps: _vm.steps,
              text_top: _vm.text_top,
              text_bottom: _vm.text_bottom,
              type: _vm.type,
              terms: _vm.terms
            },
            false
          )
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }